import type { ProductItemCondition, ProductSort, ProductStatus } from '@/shared/api/types/generated';

export type SellHistoryTabValue = 'sold' | 'removed' | 'unsold';

export interface ProductFilterValues {
  priceMin?: number;
  priceMax?: number;
  favoritesMin?: number;
  favoritesMax?: number;
}

export interface ProductFilters extends ProductFilterValues {
  brand?: string;
  itemCondition?: ProductItemCondition;
  sort?: ProductSort;
  priceMin?: number;
  priceMax?: number;
  favoritesMin?: number;
  favoritesMax?: number;
}

export interface SellHistoryFilters extends ProductFilterValues {
  brand?: string;
  itemCondition?: ProductItemCondition;
  sort?: ProductSort;
  searchText?: string;
  priceMin?: number;
  priceMax?: number;
  favoritesMin?: number;
  favoritesMax?: number;
}

export interface SellHistoryState {
  activeTab: SellHistoryTabValue;
  filters: SellHistoryFilters;
}

export const SELL_HISTORY_TAB_STATUS_MAPPING: Record<SellHistoryTabValue, ProductStatus> = {
  sold: 'sold',
  removed: 'removed',
  unsold: 'expired',
};

export const SELL_HISTORY_TABS = [
  { value: 'sold' as const, label: 'Ventes' },
  { value: 'removed' as const, label: 'Retirés' },
  { value: 'unsold' as const, label: 'Invendus' },
] as const;
